import { useContext, useMemo } from 'react';
import { UserMetadataContext } from '../components/UserMetadataProvider';

export const useGetMetadataLoadingStatus = () => {
  const { state } = useContext(UserMetadataContext);
  const hasAccess = useMemo(() => state.loadingStatus, [state]);
  return hasAccess;
};
